import { DateTime } from 'luxon';
import { DISPLAY_FORMAT, ISO_FORMAT } from '../constants';

export default function toLuxonObject(dateString, customFormat) {
  if (!dateString){
    return null
  }
  if (dateString instanceof DateTime && dateString.isValid) {
    return dateString.set({ hour: 12 });
  }
  const dateFormats = customFormat
    ? [customFormat, DISPLAY_FORMAT, ISO_FORMAT]
    : [DISPLAY_FORMAT, ISO_FORMAT];

  for (const format of dateFormats) {
    try {
      const date = DateTime.fromFormat(dateString, format, { zone: 'utc' });

      if (date.isValid) {
        return date.set({ hours: 12 });
      }
    } catch (error) {

    }
  }

  return null;
}
